<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="col-12 text-left bg-white mb-2 rounded py-3 container">
      <button type="submit" class="btn btn-success mr-2">
        <span>
          ذخیره تغییرات
          <i class="far fa-save" />
        </span>
      </button>
      <div class="col-12 text-right">
        <h4>اطلاعات پایه</h4>
        <p class="my-2">عنوان(30کاراکتر)</p>
        <input type="text" class="form-control w-25" v-model="changetitle" />
      </div>
    </div>
    <div class="row">
      <div v-if="id === 'new' || Object.keys(item).length > 0" class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <card class="card" title="بنر سری سوم ">
                  <div>
                    <div class="form-row">
                      <div
                        class="col-12 mb-3"
                        v-for="(val, i) in item.banners3"
                        :key="val"
                      >
                        <div class="form-row align-items-center">
                          <div class="col-12 col-sm-6 col-md-4">
                            <div class="form-group text-right">
                              <label class="w-100" :for="'banners3' + i"
                                >نوع بنر</label
                              >
                              <fvSelect
                                :id="'type' + i"
                                class="
                                  form-control
                                  select
                                  text-right
                                  fv-size-md
                                "
                                v-model="item.banners3[i].type"
                                :options="[
                                  { text: 'داستان', value: 'STORY' },
                                  { text: 'دسته بندی', value: 'CATEGORY' },
                                  { text: 'بلاگ', value: 'BLOG' },
                                ]"
                              />
                            </div>
                          </div>

                          <div class="col-12 col-sm-6 col-md-4">
                            <div
                              class="form-group text-right"
                              v-if="item.banners3[i].type === 'CATEGORY'"
                            >
                              <label class="w-100" :for="'banners' + i"
                                >دسته بندی</label
                              >
                              <appCategorySelect
                                id="categories"
                                :justId="true"
                                placeholder="دسته بندی"
                                v-model="item.banners3[i].id"
                              />
                            </div>

                            <div
                              class="form-group text-right"
                              v-if="item.banners3[i].type === 'STORY'"
                            >
                              <label class="w-100" :for="'banners' + i"
                                >داستان</label
                              >
                              <appStorySelect
                                :justId="true"
                                id="story"
                                placeholder="داستان"
                                v-model="item.banners3[i].id"
                              />
                            </div>

                            <div
                              class="form-group text-right"
                              v-if="item.banners3[i].type === 'BLOG'"
                            >
                              <label :for="'banners' + i" class="w-100"
                                >لینک بلاگ</label
                              >
                              <input
                                :id="'banners' + i"
                                v-model="item.banners3[i].url"
                                type="text"
                                class="fv-sm form-control"
                                placeholder="لینک بلاگ"
                              />
                            </div>
                          </div>

                          <div class="col-12 col-sm-6 col-md-4 text-right">
                            <div class="form-group text-right">
                              <label :for="'order' + i" class="">ترتیب</label>
                              <input
                                :id="'order' + i"
                                v-model.number="item.banners3[i].order"
                                type="number"
                                class="fv-sm form-control"
                                placeholder="ترتیب"
                              />
                            </div>
                          </div>

                          <div class="col-12 col-sm-6 col-md-4 text-center">
                            <button
                              style="margin-top: 7px"
                              @click.prevent="item.banners3.splice(i, 1)"
                              class="btn btn-outline-danger mr-2"
                            >
                              پاک کردن
                              <i class="fa fa-trash" />
                            </button>
                          </div>

                          <div class="col-12">
                            <div class="form-group text-right">
                              <label
                                :for="'banners' + i"
                                class="text-right mb-1"
                                >بنر</label
                              >
                              <appFileUploader
                                :id="'image' + i"
                                v-model="item.banners3[i].image"
                              />
                            </div>
                          </div>

                          <div class="col-12">
                            <hr />
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mt-3">
                        <button
                          @click.prevent="item.banners3.push({})"
                          class="btn btn-outline-primary"
                        >
                          اضافه کردن
                          <i class="fas fa-plus" />
                        </button>
                      </div>
                    </div>

                    <div class="clearfix" />
                  </div>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { API_URL2 } from "../../../env";
import Vue from "vue";
import axios from "axios";
import Modela from "modela";
import settingsModel from "../../../models/homeSettings";
import { mapActions } from "vuex";
import appFileUploader from "../../../components/appFileUploader";
import appCategorySelect from "../../../components/appCategorySelect";
import appStorySelect from "../../../components/appStorySelect";

export default {
  name: "banner-s-3",
  components: {
    appFileUploader,
    appStorySelect,
    appCategorySelect,
  },
  data() {
    const { params } = this.$route;
    const { id } = params;
    return {
      ...mapActions("main", ["crud"]),
      id,
      item: {},
      baseUrl: API_URL2,
      changetitle: "",
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const settings = await this.crud({
          action: "get",
          section: "settings/home",
          id: this.id,
          showError: true,
        });
        if (settings.data && settings.data) {
          const result = settings.data;
          let item = new Modela(settingsModel);
          item.$clean();
          item.$set(result);
          item = item.$clean().$export();
          this.item = item;
        }
      } catch (e) {
        // console.log(e)
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async getTitle() {
      try {
        const token = Vue.$cookies.get("accssToken");
        const title = await axios.get(`${this.baseUrl}/banner/title/3`, {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        this.changetitle = title.data.title;
      } catch (err) {
        console.log(err);
      }
    },
    async edit() {
      try {
        const token = Vue.$cookies.get("accessToken");
        const title = {
          id: 3,
          title: this.changetitle,
        };
        console.log("first,", title);
        const result = await axios.put(
          `${this.baseUrl}/banner/title/3`,
          JSON.stringify(title),
          {
            headers: {
              Authorization: "Bearer " + token,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
      } catch (err) {
        console.log(err);
      }
    },
    async post() {
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const post = await this.crud({
          action: "post",
          section: "settings/home",
          data: this.item,
          showError: true,
        });
        this.$successAlert();
        // this.$router.go(-1)
        await this.$router.push({ name: "dashboard" });
      } catch (e) {
        // console.log(e)
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async submit() {
      this.post();
      this.edit();
    },
  },
  async created() {
    await this.getData();
    this.getTitle();
  },
};
</script>
<style>
</style>
